import { Dispatch, SetStateAction } from "react";
import { AxiosResponse } from "axios";

export function toggleModal(setModalOpen: Dispatch<SetStateAction<boolean>>, setNurseId?: Dispatch<SetStateAction<number | undefined>>) {
  setModalOpen((prev) => !prev);
  if (setNurseId) setNurseId(undefined);
}

export async function handleNurseAction(
  nurseId: number,
  action: (id: number) => Promise<AxiosResponse>,
  setNurses: Dispatch<SetStateAction<any[]>>,
  setModalOpen: Dispatch<SetStateAction<boolean>>,
  setNurseId?: Dispatch<SetStateAction<number | undefined>>,
  onSuccess?: () => void
) {
  await action(nurseId);
  setNurses((prevNurses) => prevNurses.filter((nurse) => nurse.id !== nurseId));
  toggleModal(setModalOpen, setNurseId);
  if (onSuccess) onSuccess();
}
